<template>
  <div>
    <timeline style="font-size:14px;">
      <timeline-title bg-color="#9dd8e0" v-if="reportList.length>0">普通阶段报告</timeline-title>
      <timeline-item v-for=" (item,index) in reportList" :key="index" :hollow="false">
        <el-button type="text" @click="showDetail(item.id,item.title)">
          <!-- <div style="color:#666" > -->
          <!-- 第{{index+1}}次阶段报告 -->
          {{item.title}}
          <span style="margin-left:10px;">{{item.addtime}}</span>
          <!-- </div>  -->
        </el-button>
      </timeline-item>

      <timeline-title bg-color="#9dd8e0" v-if="reportQuarter.length>0">阶段性报告</timeline-title>
      <timeline-item v-for=" value in reportQuarter" :key="value.id" :hollow="false">
        <el-button type="text" v-if="value.id" @click="showDetail(value.id,value.title)">
          {{value.title}}
          <span style="margin-left:10px;">{{value.addtime}}</span>
        </el-button>
        <span type="text" v-else>
          {{value.title}}
          <span style="margin-left:10px;color:red">{{value.addtime}}</span>
        </span>
      </timeline-item>
    </timeline>
    <div v-if="reportQuarter.length<=0&&reportList.length<=0">
      <p style="clear: both; font-size:14px; color:#666; padding-bottom:10px;">
        <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;暂无报告~
      </p>
    </div>

    <el-dialog :title="reportData.title" :visible.sync="dialogFormVisible">
      <table class="table">
        <tr>
          <th>概要</th>
          <td colspan="4">{{reportData['summary']}}</td>
        </tr>
        <tr>
          <th>具体实施</th>
          <td colspan="4">{{reportData['implementation']}}</td>
        </tr>
        <tr>
          <th>总结活动准备</th>
          <td colspan="4">{{reportData['preparation']}}</td>
        </tr>
        <tr>
          <th>总结活动执行</th>
          <td colspan="4">{{reportData['execution']}}</td>
        </tr>
        <tr>
          <th>筛查人数</th>
          <td colspan="4">{{reportData['report_screen_number']}}</td>
        </tr>
        <tr>
          <th>筛查名单excel</th>
          <td colspan="4">
            <!-- <span
              @click="downFile(reportData.report_screen_list_file_id, reportData.report_screen_list_file_name)"
              style="text-decoration: underline; color: #333; cursor: pointer;color:#4682B4 "
            >{{ reportData.report_screen_list_file_name }}</span> -->
            <a
              :href="reportData.report_screen_list_file_url"
              target="_blank"
            >{{reportData.report_screen_list_file_name}}</a>
          </td>
        </tr>
        <tr>
          <th>项目附件</th>
          <td colspan="4">
            <!-- <span
              @click="downFile(reportData.progress_file_id, reportData.progress_file_name)"
              style="text-decoration: underline; color: #333; cursor: pointer;color:#4682B4 "
            >{{ reportData.progress_file_name }}</span> -->
            <a
              :href="reportData.progress_file_url"
              target="_blank"
            >{{reportData.progress_file_name}}</a>
          </td>
        </tr>
        <tr>
          <th>盖章扫描件集合</th>
          <td colspan="4">
            <viewer :images="reportData.report_stamp_pic">
              <img
                v-for="(value,index) in reportData.report_stamp_pic"
                :src="value.pic_path"
                :key="index"
                style="width: 50px; height: 50px;cursor: pointer;margin-right:5px"
              />
              <p style="clear: both; padding-top: 10px">
                <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;点击上方图片查看/下载大图
              </p>
            </viewer>
          </td>
        </tr>
        <tr>
          <th>开展细项</th>
          <td colspan="4">
            <div v-html="reportData.cases"></div>
          </td>
        </tr>
        <tr>
          <th>典型案例</th>
          <td colspan="4">
            <div v-html="reportData.development_item"></div>
          </td>
        </tr>
      </table>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-close"
          @click="dialogFormVisible = false"
        >关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Timeline, TimelineItem, TimelineTitle } from "vue-cute-timeline";
export default {
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  components: {
    Timeline,
    TimelineItem,
    TimelineTitle
  },
  data() {
    return {
      dialogFormVisible: false,
      reportList: [], //普通报告
      reportQuarter: [], //阶段性报告
      reportData: {} //
    };
  },

  watch: {},
  methods: {
    showDetail(id, title) {
      this.$db
        .post(this.$db.config.getCfProReportDetail, { id: id })
        .then(res => {
          if (res && res.code == 200) {
            this.dialogFormVisible = true;
            this.reportData = res.data;
            this.reportData.title = title;
          }
        });
    },
    downFile(id, name) {
      this.$db
        .downFilePost(this.$db.config.downloadFileUrl, { file_id: id })
        .then(res => {
          if (res.hasOwnProperty("code")) {
            var enc = new TextDecoder("utf-8");
            var result = JSON.parse(enc.decode(new Uint8Array(res)));
            if (result.code !== 200) {
              this.$message.warning(result.msg);
            }
          } else {
            this.download(res, name);
          }
        });
    },
    // 下载文件
    download(data, name) {
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let alink = document.createElement("a");
      alink.href = url;
      alink.download = name; //文件名
      alink.click();
      this.downConfirm = false;
    },

    //获取报告列表
    getReportList() {
      this.$db
        .post(this.$db.config.getCfProReportList, {
          project_id: this.id
        })
        .then(res => {
          if (res && res.code == 200) {
            this.reportList = res.data.freedom;
            this.reportQuarter = res.data.translate;
          }
        });
    }
  },
  created() {
    if (this.id > 0) {
      this.getReportList();
    }
  }
};
</script>
<style lang="scss" scoped>
.table td,
.table th {
  border: 1px solid #ccc;
}

.table th {
  width: 15%;
  min-width: 100px;
  padding: 20px 5px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
}
.disc {
  height: 100px;
}

.table td {
  padding: 20px 5px;
  font-size: 14px;
  font-family: "微软雅黑";
  font-weight: 100;
  text-align: left;
  min-width: 80px;
}
.table {
  margin: 50px auto;
  max-width: 900px !important;
  width: calc(100% - 10px);
  border: 0;
  border-collapse: collapse;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/info/detail_report.vue